import React from 'react'
import Breadcrumb from '../../breadcrumbMeta/Breadcrumb';
import Meta from '../../breadcrumbMeta/Meta';

const Checkout = () => {
  return (
    <>
       <Meta title={"Checkout"} />
      <Breadcrumb title="Checkout" />
    </>
  )
}

export default Checkout
